var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NotificationBar',{attrs:{"open":_vm.isNotificationBar,"speed":2.3,"content":_vm.notificationBarContent},on:{"close":function($event){return _vm.closeNotificationBar()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }